export const rightMenu = [
    { label: "Nature",link:"natures" },
    { label: "Product",link:"product" },
    { label: "Street",link:"street" },
    { label: "Travel",link:"travel" },
    { label: "Willide",link:"wildlife" },
    { label: "Video",link:"videos" },
]

export const leftMenu = [
    { label: "Home",link:"home" },
    { label: "About",link:"about" },
    { label: "Contact",link:"contact" },
]
